export default __webpack_public_path__ + "static/media/ARPHICPL.03ba47de.TXT";